// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.png";
import logo from "./assets/logo.png";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import laravel from "./assets/techstack/laravel.png";
import node from "./assets/techstack/node.png";
import php from "./assets/techstack/php.png";

// Porject Images
import projectImage1 from "./assets/projects/project1.png";
import projectImage2 from "./assets/projects/project2.png";
import projectImage3 from "./assets/projects/project3.png";
import projectImage4 from "./assets/projects/project4.png";
import projectImage5 from "./assets/projects/project5.png";
import projectImage6 from "./assets/projects/project6.png";
import projectImage7 from "./assets/projects/project7.png";
import projectImage8 from "./assets/projects/project8.png";
import projectImage9 from "./assets/projects/project9.png";
import projectImage10 from "./assets/projects/project10.png";
import projectImage11 from "./assets/projects/project11.png";
import projectImage12 from "./assets/projects/project12.png";
import projectImage13 from "./assets/projects/project13.png";
import projectImage14 from "./assets/projects/project14.png";
import projectImage15 from "./assets/projects/project15.png";
import projectImage16 from "./assets/projects/project16.png";
import projectImage17 from "./assets/projects/project17.png";
import projectImage18 from "./assets/projects/project18.png";
import projectImage19 from "./assets/projects/project19.png";
import projectImage20 from "./assets/projects/project20.png";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Md Azizul Arif",
  tagline: "I build software and website",
  img: profile,
  about: `Attributes - Attention to detail, Problem-solving, Leadership, Strong communication, Ability to work under pressure, Can do anything attitude.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/md-azizul-arif-409548112/",
  github: "https://github.com/Azizul109",
  gitlab: "https://gitlab.com/azizularif420",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Software Engineer",
    Company: `Mazegeek Technologies Limited`,
    Location: "Banani, Dhaka",
    Type: "Full Time",
    Duration: "May 2024 - Currently Working",
  },
  {
    Position: "Software Engineer",
    Company: `UCSI University Bangladesh Branch Campus`,
    Location: "Banani, Dhaka",
    Type: "Full Time/Part Time",
    Duration: "Mar 2024 - Jun 2025",
  },
  {
    Position: "Software Engineer",
    Company: `Nogor Solutions Limited`,
    Location: "Niketon, Gulshan-1, Dhaka",
    Type: "Full Time",
    Duration: "Sep 2022 - Feb 2024",
  },
  {
    Position: "Junior Software Engineer",
    Company: `Namespace IT`,
    Location: "Uttara, Dhaka",
    Type: "Full Time",
    Duration: "Aug 2021 - Sep 2022",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Master's of Computer Science & Engineering",
    Company: "East West University",
    Location: "Dhaka",
    Type: "Full Time",
    Duration: "2021 - 2023",
  },
  {
    Position: "Bachelor of Engineering in Software Engineering",
    Company: `Sichuan Univeristy`,
    Location: "China",
    Type: "Full Time",
    Duration: "2017 - 2021",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
  laravel: laravel,
  node: node,
  php: php,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "Partscargo Website",
    image: projectImage1,
    description: `ecommerce website for auto parts with PayPal and Stripe integration. Order placed from website will go directly to Partzroot`,
    techstack: "HTML/CSS, JavaScript, Laravel, Vue, Node",
    previewLink: "https://partscargo.com/",
    githubLink: "https://partscargo.com/",
  },
  {
    title: "Partzroot Software",
    image: projectImage2,
    description: `in-house web application built from scratch capable of managing the entire auto parts order
life cycle`,
    techstack: "HTML/CSS, JavaScript, Laravel, Vue, Node",
    previewLink: "https://admin.staging.partzroot.com/admin-login",
    githubLink: "https://admin.staging.partzroot.com/admin-login",
  },
  {
    title: "Maxxecom",
    image: projectImage3,
    description: `web application built to integrate eBay and Amazon stores to achieve centralized
operational control`,
    techstack: "HTML/CSS, JavaScript, Laravel, React, Node",
    previewLink: "https://flawless.maxxecom.com/dashboard",
    githubLink: "https://flawless.maxxecom.com/dashboard",
  },
  {
    title: "Auto Parts Data Warehouse",
    image: projectImage4,
    description: `specialized database designed to store and manage a dataset relating to
the auto parts industry`,
    techstack: "HTML/CSS, JavaScript, Laravel, React, Node",
    previewLink: "https://data.partscargo.com/home",
    githubLink: "https://data.partscargo.com/home",
  },
  {
    title: "UCSI University Bangladesh Branch Campus Website",
    image: projectImage5,
    description: `maintain, update and modify the Bangladesh branch
campus website regularly`,
    techstack: "HTML/CSS, JavaScript, PHP, Drupal",
    previewLink: "https://www.bangladesh.ucsiuniversity.edu.my/",
    githubLink: "https://github.com/Azizul109/ucsi-university",
  },
  {
    title: "HRM",
    image: projectImage6,
    description: `software to handle human resource operation for the university collaborating with Malaysian
development team`,
    techstack: "HTML/CSS, JavaScript, Node",
    previewLink:
      "https://iisv2bd.ucsiuniversity.edu.my/bgd/f?p=510:43:10851602668650:::::",
    githubLink:
      "https://iisv2bd.ucsiuniversity.edu.my/bgd/f?p=510:43:10851602668650:::::",
  },
  {
    title: "Student Portal Software",
    image: projectImage7,
    description: `software to manage the students admission process and overall payment,
semester related coursework and many mare`,
    techstack: "HTML/CSS, JavaScript, Node",
    previewLink:
      "https://iisv2bd.ucsiuniversity.edu.my/bgd/f?p=520:LOGIN_DESKTOP:14171855893794:::::IK",
    githubLink:
      "https://iisv2bd.ucsiuniversity.edu.my/bgd/f?p=520:LOGIN_DESKTOP:14171855893794:::::IK",
  },
  {
    title: "Library Management Software",
    image: projectImage8,
    description: `Library management software done from scratch with RFID scanner device integration for World
University Bangladesh`,
    techstack: "HTML/CSS, JavaScript, React, Laravel, Java, Node",
    previewLink: "https://library.wub.edu.bd/",
    githubLink: "https://library.wub.edu.bd/",
  },
  {
    title: "BIMRAD",
    image: projectImage9,
    description: `Journal submission software done from scratch to submit university research and publications for
university`,
    techstack: "HTML/CSS, JavaScript, React, Laravel, Node",
    previewLink: "https://bimradbd.org/journal",
    githubLink: "https://bimradbd.org/journal",
  },
  {
    title: "BCS",
    image: projectImage10,
    description: `Bangladesh Computer Society website development with member portal management software
development from scratch`,
    techstack: "HTML/CSS, JavaScript, Vue, Laravel, Node",
    previewLink: "https://bcsbd.org.bd/",
    githubLink: "https://bcsbd.org.bd/",
  },
  {
    title: "BEPZA",
    image: projectImage11,
    description: `develop the dynamic website of bepza with the backend management capability for website`,
    techstack: "HTML/CSS, JavaScript, Vue, Laravel, Node",
    previewLink: "https://bepza.gov.bd/",
    githubLink: "https://bepza.gov.bd/",
  },
  {
    title: "BASIS",
    image: projectImage12,
    description: `upgradation and modification of basis website and member portal management software to
reduce the hassle for basis member`,
    techstack: "HTML/CSS, JavaScript, Vue, Laravel, Node",
    previewLink: "https://basis.org.bd/",
    githubLink: "https://basis.org.bd/",
  },
  {
    title: "E-CAB",
    image: projectImage13,
    description: `upgradation and modification of e-cab website and member portal management software to
reduce the hassle for e-cab member`,
    techstack: "HTML/CSS, JavaScript, Vue, Laravel, Node",
    previewLink: "https://e-cab.net/",
    githubLink: "https://e-cab.net/",
  },
  {
    title: "MIST",
    image: projectImage14,
    description: `Military institute of science and technology civil engineering department website and dynamic
backend management software development`,
    techstack: "HTML/CSS, JavaScript, Vue, Laravel, Node",
    previewLink: "https://ce-cats.mist.ac.bd/",
    githubLink: "https://ce-cats.mist.ac.bd/",
  },
  {
    title: "BIMRAD",
    image: projectImage15,
    description: `Bangladesh Institute of Maritime Research and Development website and dynamic backend
management software development`,
    techstack: "HTML/CSS, JavaScript, Vue, Laravel, Node",
    previewLink: "https://bimradbd.org/",
    githubLink: "https://bimradbd.org/",
  },
  {
    title: "Feni University",
    image: projectImage16,
    description: `Feni University dynamic website development`,
    techstack: "HTML/CSS, JavaScript, Vue, Laravel, Node",
    previewLink: "https://feniuniversity.ac.bd/",
    githubLink: "https://feniuniversity.ac.bd/",
  },
  {
    title: "Definity Legend",
    image: projectImage17,
    description: `Gaming website design for Malaysian client, where main idea was to design the website with gaming vie`,
    techstack: "HTML/CSS, JavaScript, React",
    previewLink: "http://www.definitylegend.com/",
    githubLink: "http://www.definitylegend.com/",
  },
  {
    title: "Sylhet City Corporation",
    image: projectImage18,
    description: `Website for Sylhet City Corporation, where dynamic website is made and backend software to handle the frontend part`,
    techstack: "HTML/CSS, JavaScript, PHP, Laravel",
    previewLink: "https://sylhet-city-corporation.netlify.app/",
    githubLink: "https://sylhet-city-corporation.netlify.app/",
  },
  {
    title: "Firecommerce",
    image: projectImage19,
    description: `Ecommerce website where user can register, login and add item to cart for order, payment with Stripe and Paypal`,
    techstack: "HTML/CSS, JavaScript, React, Node, Firbase, MongoDB",
    previewLink: "https://firecommerce-arif.netlify.app/login",
    githubLink: "https://firecommerce-arif.netlify.app/login",
  },
  {
    title: "Food Recipe App",
    image: projectImage20,
    description: `API integration with third party to get the specific ingredients for a dish. Suppose include mango will show dish with mango`,
    techstack: "HTML/CSS, JavaScript, React, Node, Firbase",
    previewLink: "https://recipe-app-arif.netlify.app/",
    githubLink: "https://recipe-app-arif.netlify.app/",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "azizularifnahim52@gmail.com",
  website: "https://portfolio-arif.netlify.app/",
  phone: "01726058935",
};
